// Habilitación del técnico: las seis aceptaciones, su documento, la selfie y el título en root.
// El servidor decide todo (`server/tecnico-habilitacion.js`); acá solo se pregunta y se pide.
//
// 🔒 El token que viaja es el de la SESIÓN del técnico: el hub-api lo verifica con su firma y
// rechaza el `alg:none` que el navegador se fabrica solo. Una aceptación legal no la puede dar
// nadie más que la persona, así que no hay atajo de administración para ellas.
import { hubGet, hubPost } from './hub';
import { getToken } from './auth';
import { tokenParaBackend } from './adminAuth';

function tokenDeSesion() {
  try {
    return getToken() || '';
  } catch {
    return '';
  }
}

/** Qué le falta y si hoy puede operar. `fresco` salta la caché corta de root (al volver de Verifik). */
export async function estadoHabilitacion(email, { fresco = false } = {}) {
  const t = tokenDeSesion();
  return hubGet(
    'tecnico/habilitacion',
    { email, fresco: fresco ? '1' : '' },
    t ? { headers: { Authorization: `Bearer ${t}` } } : {},
  );
}

/** Acepta una o varias. Cada una queda como su propia fila, con versión, fecha e IP. */
export async function aceptarCondiciones(email, claves) {
  return hubPost('tecnico/aceptaciones', { email, claves, token: tokenDeSesion() });
}

/** Revoca una (la de datos y la de débitos son revocables por ley y por contrato). */
export async function revocarCondicion(email, clave) {
  return hubPost('tecnico/aceptaciones/revocar', { email, clave, token: tokenDeSesion() });
}

export async function guardarDocumentoTecnico(email, tipoDocumento, numeroDocumento) {
  return hubPost('tecnico/documento', {
    email, tipo_documento: tipoDocumento, numero_documento: numeroDocumento, token: tokenDeSesion(),
  });
}

/** Pide a root el enlace de Verifik para la selfie con el documento. */
export async function iniciarSelfieTecnico(email) {
  return hubPost('tecnico/selfie', { email, token: tokenDeSesion() });
}

/** Pide a root la consulta del título en el COPNIA. */
export async function verificarTituloTecnico(email) {
  return hubPost('tecnico/titulo', { email, token: tokenDeSesion() });
}

/** EMPRESA: designa a su profesional técnico (root #118). El profesional tiene que aceptar después. */
export async function designarProfesionalEmpresa(email, { tipoDocumento, numeroDocumento, correo }) {
  return hubPost('tecnico/empresa/profesional', {
    email, tipo_documento: tipoDocumento, numero_documento: numeroDocumento, correo, token: tokenDeSesion(),
  });
}

/**
 * TÉCNICO: acepta ser el profesional de una empresa. Solo viaja el NIT: el documento y el correo los
 * pone el servidor desde la ficha y la sesión de quien acepta.
 */
export async function aceptarSerProfesional(email, nit) {
  return hubPost('tecnico/empresa/profesional/aceptar', { email, nit, token: tokenDeSesion() });
}

/** ADMIN: aprueba (o retira) la tarjeta CONTE revisada a mano como vía de título. */
export async function aprobarTituloConte({ technicianId, aprobar = true, notas = null }) {
  return hubPost('tecnico/titulo/conte', {
    technician_id: technicianId, aprobar, notas, token: tokenParaBackend() || '',
  });
}
